// @ts-nocheck
import _ from 'lodash';

export const CaseInsensitiveFilter = (filter, row) =>
  _.includes((row[filter.id] || '').toLowerCase(), filter.value.toLowerCase());

export const RegularExpressionFilter = (filter, row) => {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id])
        .toLowerCase()
        .match(new RegExp(`${filter.value.toLowerCase()}`))
    : false;
};
